<template>
    <div>

        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <!-- <a class="navbar-brand ml-3">Cek Status Truk</a> -->
                <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor Polisi"
                        aria-label="Search"
                        style="font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">
            <div class="mb-4 row">
                <div class="col-md-5"></div>
                <!-- <div class="col-md-2 text-right">
                    <button
                        class="btn border-secondary rounded shadow w-100"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                        @click="modal.upload = true"
                    >Tambah</button>
                </div> -->
                <div class="col-md-2">
                    <h3 
                        class="tableTitle text-left"
                        style="font: normal normal normal 16px/25px Poppins;"
                    >Nopol Setting</h3>
                </div>
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-md-4">
                            <button
                                class="btn rounded w-100"
                                type="button"
                                style="background-color: #CEEDF8; color: #343434; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                                @click="modal.upload = true"
                            >Upload File</button>
                        </div>
                        <div class="col-md-4">
                            <button
                                class="btn rounded w-100"
                                type="button"
                                style="background-color: #CEEDF8; color: #343434; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                                @click="downloadNopol"
                            >Download XLSX</button>
                        </div>
                        <div class="col-md-4">
                            <button
                                class="btn rounded w-100"
                                type="button"
                                style="background-color: #CEEDF8; color: #343434; height: 100%; font-weight: bold; font: normal normal normal 12px/18px Poppins;"
                                @click="modal.new = true"
                            >New Nopol</button>
                        </div>
                    </div>
                </div>
            </div>

            <vue-universal-table
                api_url="/api/settings/get-nopol"
                :filter="filter"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :buttons="vue_universal_table.buttons"
                :infinite_scroll="true"

                sort_order="DESC"
                sort_by="updated_at"
                style="font: normal normal normal 12px/18px Poppins;"

                @onEditNopol="editTruck"
                @onDeleteNopol="deleteTruck"
            ></vue-universal-table>
        </div>
        <!-- Table End -->

        <!-- Modal Start -->
        <cu-nopol-truck
            v-if="modal.new || modal.edit"
            :data="modal.editData"
            api_new="/api/settings/add-nopol"
            api_edit="/api/settings/update-nopol"
            @refreshData="vue_universal_table.update++"
            @closeModal="modal.new = false; modal.edit = false; modal.editData = null"
        ></cu-nopol-truck>

        <NOPOLTruckUpload 
            v-if="modal.upload"
            @closeModal="modal.upload = false"
            @onFinish="vue_universal_table.update++"
        />
        <!-- Modal End -->

    </div>
</template>

<script>
    import qs from 'qs'

    import NOPOLTruckUpload from './children/NOPOLTruckUpload.vue'
    import cuNopolTruck from './children/CUNopolTruck'

    export default {
        metaInfo : {
            title : 'NOPOL Truck'
        },
        data () {
            return {
                modal : {
                    new : false,
                    edit : false,
                    editData : null,
                    upload : false,
                },
                filter : {
                    search : null
                },
                vue_universal_table : {
                    fields : [
                        {title:"NOPOL", variable:"nopol"},
                        {title:"EKSPEDISI", variable:"ekspedisi"},
                        {title:"DRIVER", variable:"fullname"},
                        {title:"Last Updated", variable:"updated_at"},
                    ],
                    buttons : [
                        {title:"editNopol", class:"border-secondary rounded shadow fas fa-edit"},
                        {title: "deleteNopol", variable: "id", class: "border-secondary rounded shadow fas fa-trash"}
                    ],
                    filter : {},
                    update : 0,
                },
            }
        },
        components : {
            cuNopolTruck,
            NOPOLTruckUpload
        },
        mounted () {

        },
        methods : {
            editTruck (a) {
                this.modal.editData = JSON.parse(a);
                this.modal.edit = true;
            },
            deleteTruck(id) {
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "Nopol can't be restored if already deleted",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085D6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'Delete'
                }).then((result) => {
                    if (result.value) {
                        this.$swal({
                            title: 'Loading....'
                        })
                        this.$swal.showLoading();

                        this.$http.delete(`/api/settings/delete-nopol/${id}`)
                        .then(()=>{
                            this.$swal.close();
                            this.$swal.fire({
                                title : "Success!",
                                icon : "success",
                                type : "success",
                                text : `Nopol telah dinonaktifkan`
                            })
                            this.vue_universal_table.update++;
                        }).catch((error)=>{
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : error.response.data.message
                            })
                        })
                    }
                })
            },
            downloadNopol () {
                for (var i in this.filter) if (this.filter[i] == '') this.filter[i] = null

                this.$http.get(`/api/settings/get-nopol?pagination=false&${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.exportExcel(resp.data.data, "Nomor Polisi Truck Download");
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>